import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class LinkCheck {
  linkUnavailableCheck(url: string): boolean {
    if (!url || this.isGUID(url)) {
      return false;
    }

    try {
      const typedURL = new URL(url);
      return typedURL.searchParams.has("unavailable");
    } catch {
      return false;
    }
  }

  isGUID(urlString: string) {
    const guidRegExp = new RegExp(
      "^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$",
      "i"
    );
    return guidRegExp.test(urlString);
  }
}
